import type { NotificationCategory } from '../notification-dto';
import { demandFrameworkChangedDescriptor, demandStageChangedDescriptor } from './demands';
import {
  commentMentionDescriptor,
  feedbackDescriptor,
  ideaCommentsDescriptor,
  staleIdeasDescriptor,
} from './ideas-and-feedback';
import { invitesDescriptor, jiraReauthDescriptor } from './invites-and-reauth';
import {
  exportCompletionDescriptor,
  objectiveDriftDetectedDescriptor,
  objectiveHealthChangedDescriptor,
  planPublishedDescriptor,
  portfolioCreatedDescriptor,
  teamAssignmentChangedDescriptor,
} from './loop';
import { capacityOrphanedInstanceDescriptor, trialsDescriptor } from './trials-and-capacity';
import type { CategoryDescriptor } from './types';
import {
  workIntegrationDisconnectedDescriptor,
  workIntegrationExcludedTeamsDescriptor,
  workIntegrationPublishCompleteDescriptor,
  workIntegrationScheduleDisabledDescriptor,
  workIntegrationSetupCompleteDescriptor,
  workIntegrationSyncErrorDescriptor,
} from './work-integration';

export const NOTIFICATION_REGISTRY: { [C in NotificationCategory]: CategoryDescriptor<C> } = {
  invites: invitesDescriptor,
  trials: trialsDescriptor,
  jira_reauth: jiraReauthDescriptor,
  work_integration_schedule_disabled: workIntegrationScheduleDisabledDescriptor,
  work_integration_sync_error: workIntegrationSyncErrorDescriptor,
  work_integration_setup_complete: workIntegrationSetupCompleteDescriptor,
  work_integration_disconnected: workIntegrationDisconnectedDescriptor,
  work_integration_excluded_teams: workIntegrationExcludedTeamsDescriptor,
  work_integration_publish_complete: workIntegrationPublishCompleteDescriptor,
  capacity_orphaned_instance: capacityOrphanedInstanceDescriptor,
  portfolio_created: portfolioCreatedDescriptor,
  team_assignment_changed: teamAssignmentChangedDescriptor,
  plan_published: planPublishedDescriptor,
  demand_framework_changed: demandFrameworkChangedDescriptor,
  demand_stage_changed: demandStageChangedDescriptor,
  objective_health_changed: objectiveHealthChangedDescriptor,
  objective_drift_detected: objectiveDriftDetectedDescriptor,
  feedback: feedbackDescriptor,
  idea_comments: ideaCommentsDescriptor,
  comment_mention: commentMentionDescriptor,
  stale_ideas: staleIdeasDescriptor,
  export_completion: exportCompletionDescriptor,
};

export type { CategoryDescriptor, DataFor, ServerCopyTranslate } from './types';
export { extractRelativeActionUrl, requireFields, resolveKey } from './types';

export const getCategoryDescriptor = <C extends NotificationCategory>(
  category: C,
): CategoryDescriptor<C> => NOTIFICATION_REGISTRY[category];
